import { TextField, TextFieldProps } from '@mui/material'
import React, { useState } from 'react'

export type TextFieldTextProps = TextFieldProps & {
  mask?: (value: string) => string
  value: string
}

function TextFieldText({ variant = 'outlined', ...props }: TextFieldTextProps) {
  const [value, setValue] = useState<string>(props.value)
  const { onChange, mask, ...internalProps } = props

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
    if (props.onChange) props.onChange(e)
    if (mask) setValue(mask(e.target.value))
    else setValue(e.target.value)
  }

  return <TextField {...internalProps} value={value} onChange={handleChange} />
}
export default TextFieldText
